import { Invoice, InvoiceAcceptance } from './types';
import { renderInvoicePdf } from './downloadInvoice';

const asPdfBlob = (blob: Blob) => (
    blob.type === 'application/pdf'
        ? blob
        : new Blob([blob], { type: 'application/pdf' })
);

export const printPdfBlob = (blob: Blob, title = 'Print invoice') => {
    const url = URL.createObjectURL(asPdfBlob(blob));
    const iframe = document.createElement('iframe');
    iframe.setAttribute('aria-hidden', 'true');
    iframe.title = title;
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    iframe.style.opacity = '0';
    iframe.style.border = '0';

    let printed = false;
    let cleaned = false;

    const cleanup = () => {
        if (cleaned) return;
        cleaned = true;
        URL.revokeObjectURL(url);
        iframe.remove();
    };

    const print = () => {
        if (printed) return;
        const frameWindow = iframe.contentWindow;
        if (!frameWindow) return;
        printed = true;
        frameWindow.focus();
        try {
            frameWindow.print();
        } catch {
            const opened = window.open(url, '_blank');
            if (!opened) {
                cleanup();
                throw new Error('Could not print invoice');
            }
        }
        window.setTimeout(cleanup, 60_000);
    };

    iframe.addEventListener('load', () => {
        window.setTimeout(print, 50);
    });
    document.body.appendChild(iframe);
    iframe.src = url;
    window.setTimeout(print, 500);
};

const printInvoice = async (
    invoice: Invoice,
    acceptance: InvoiceAcceptance | null = null,
    agentId = '',
) => {
    const blob = asPdfBlob(await renderInvoicePdf(invoice, acceptance, agentId));
    printPdfBlob(blob);
};

export default printInvoice;
